var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"monitor-types-cell"},_vm._l((_vm.monitorTypesInner),function(item,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(_vm.$t(item))+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }